
<template>
  <m-layout>
    <div fill-height class="settings fill-height" style="width:100%; max-width:100%; position:relative">
          <!-- <v-btn
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="dialog = !dialog"
            style="top: 5px;"
            >
            <v-icon>add</v-icon>
          </v-btn> -->
      <v-card-title class="m-page__title" >
        <span class="headline">Settings</span>
      </v-card-title>
      <div>
          <v-container
            class="grey lighten-5 mb-2"
          >
            <v-row
              align="start"
              no-gutters
            >
              <v-col
              >
                <v-card
                  class="pa-2"
                  outlined
                  tile
                >
                  One of three columns
                </v-card>
              </v-col>
            <v-col
              sm="12"
              md="6"
            >
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="15"
                dense
              >
              <template v-slot:item.variable="props">
                <v-edit-dialog
                :return-value.sync="props.item.variable"
                large
                persistent
                @save="save(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
                > {{ props.item.variable }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.variable"
                      :rules="[max25chars]"
                      label="Edit"
                      single-line
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
            <template v-slot:item.value="props">
              <v-edit-dialog
                :return-value.sync="props.item.value"
                large
                persistent
                @save="save(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div>{{ props.item.value }}</div>
                <template v-slot:input>
                  <div class="mt-4 title">Update value</div>
                </template>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.value"
                    :rules="[max25chars]"
                    label="Edit"
                    single-line
                    counter
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            </v-data-table>
            </v-col>

            </v-row>
          </v-container>
      </div>
    </div>
  </m-layout>
</template>
<script>
export default {
  data () {
    return {
      items: [],
      pagination: {},
      dialog: false,
      max25chars: v => v.length <= 25 || 'Input too long!',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'variable',
        },
        { text: 'Value', value: 'value' }
      ]
    };
  },
  methods: {
    save (data) {
      console.log('Dialog save', data);
      var app = this;
      return new Promise((resolve, reject) => {
        app.$http
        .post('service/settings/save', {
          id: data.id,
          variable: data.variable,
          value: data.value
        })
        .then(response => {
          // this.getEvents(this.driver.id);
          console.log('save response settings', response);
          resolve(response);
        })
        .catch(function (error) {
          console.log('catch settings:', error);
        });
      })
    },
    cancel () {
      console.log('Dialog cancel')
    },
    open () {
      console.log('Dialog open')
    },
    close () {
      console.log('Dialog closed')
    },
    getData () {
      var app = this;
      this.$http
      .get('service/settings')
      .then(response => {
        console.log('settings: ', response.data);
        app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  created () {
    this.getData();
  }
};
</script>
<style lang="scss">
.settings {
  .theme--light.v-data-table {
    background-color: transparent;
  }
}
</style>
